import { render, staticRenderFns } from "./MedicinePageSendDialog.vue?vue&type=template&id=5bacd742"
import script from "./MedicinePageSendDialog.vue?vue&type=script&lang=js"
export * from "./MedicinePageSendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports